/* eslint-disable react/prop-types */
import FalconCardHeader from 'components/common/FalconCardHeader';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React from 'react';
import { round } from 'lodash';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent,
  DatasetComponent
]);

const getOption = (data, chartMetrics) => ({
  color: [getColor('primary'), getColor('gray-300')],
  dataset: { source: data },
  tooltip: {
    trigger: 'item',
    padding: [7, 10],
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    transitionDuration: 0,
    formatter: function (params) {
      return `<div className="fw-semi-bold">${
        params.seriesName
      }</div><div className="fs--1 text-600"><strong>${
        params.name
      }:</strong> ${round(
        params.value[params.componentIndex + 1],
        2
      )} ha</div>`;
    }
  },
  legend: {
    data: chartMetrics,
    left: 'left',
    itemWidth: 10,
    itemHeight: 10,
    borderRadius: 0,
    icon: 'circle',
    inactiveColor: getColor('gray-400'),
    textStyle: { color: getColor('gray-700') }
  },
  xAxis: {
    type: 'category',
    axisLabel: { color: '#87848A' },
    axisLine: {
      lineStyle: {
        color: getColor('gray-400'),
        type: 'dashed'
      }
    },
    axisTick: false,
    boundaryGap: true
  },
  yAxis: {
    axisPointer: { type: 'none' },
    axisTick: 'none',
    splitLine: {
      lineStyle: {
        color: getColor('gray-400'),
        type: 'dashed'
      }
    },
    axisLine: { show: false },
    axisLabel: {
      color: '#87848A',
      fontSize: 12,
      formatter: value => `${value}`
    }
  },
  series: [
    {
      type: 'bar',
      barWidth: '10px',
      barGap: '30%',
      label: { show: false },
      z: 10,
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: getColor('primary')
      }
    },
    {
      type: 'bar',
      barWidth: '10px',
      barGap: '30%',
      label: { show: false },
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: getColor('secondary')
      }
    },
    {
      type: 'bar',
      barWidth: '10px',
      barGap: '30%',
      label: { show: false },
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: getColor('success')
      }
    }
  ],
  grid: {
    right: '0',
    left: '5',
    bottom: '5',
    top: '15%',
    containLabel: true
  }
});

const LandUseAndLandCoverChart = ({ landCoverChartData }) => {
  const series = landCoverChartData.data.map(obj => obj.name);
  let data = [];
  data.push(['product'].concat(landCoverChartData.data.map(obj => obj.name)));
  for (let i = 0; i < landCoverChartData.series.length; i++) {
    let row = [landCoverChartData.series[i]];
    for (let j = 0; j < landCoverChartData.data.length; j++) {
      if (j >= 0 && j < landCoverChartData.data.length) {
        let data = landCoverChartData.data[j].data;
        if (i >= 0 && i < data.length) {
          row.push(data[i]);
        } else {
          row.push(null);
        }
      } else {
        row.push(null);
      }
    }
    data.push(row);
  }

  if (!series.includes('product')) {
    series.unshift('product');
  }
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOption(data, series)}
      style={{ minHeight: '25.75rem' }}
    />
  );
};

LandUseAndLandCoverChart.propTypes = {
  data: PropTypes.array
};

export default LandUseAndLandCoverChart;
